export const pluralize = (string, length, pluralForm='s') => {
  return `${string}${length > 1 ? pluralForm : ''}`;
}